import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e7bfd08"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<figure data-v-2e7bfd08><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" data-v-2e7bfd08><g clip-path=\"url(#clip0_198_1747)\" data-v-2e7bfd08><path d=\"M9.29404 7.89904L15.5 1.68604C15.6857 1.50039 15.79 1.24859 15.79 0.986043C15.79 0.723492 15.6857 0.471695 15.5 0.286043C15.3144 0.100392 15.0626 -0.00390625 14.8 -0.00390625C14.5375 -0.00390625 14.2857 0.100392 14.1 0.286043L7.90004 6.49904L1.68604 0.289043C1.50039 0.103392 1.24859 -0.00090625 0.986043 -0.00090625C0.723492 -0.00090625 0.471695 0.103392 0.286043 0.289043C0.100392 0.474695 -0.00390625 0.726492 -0.00390625 0.989043C-0.00390625 1.25159 0.100392 1.50339 0.286043 1.68904L6.50004 7.89904L0.289043 14.107C0.103392 14.2927 -0.00090625 14.5445 -0.00090625 14.807C-0.00090625 15.0696 0.103392 15.3214 0.289043 15.507C0.474695 15.6927 0.726492 15.797 0.989043 15.797C1.25159 15.797 1.50339 15.6927 1.68904 15.507L7.90004 9.29304L14.108 15.499C14.2937 15.6847 14.5455 15.789 14.808 15.789C15.0706 15.789 15.3224 15.6847 15.508 15.499C15.6937 15.3134 15.798 15.0616 15.798 14.799C15.798 14.5365 15.6937 14.2847 15.508 14.099L9.29404 7.89904Z\" data-v-2e7bfd08></path></g><defs data-v-2e7bfd08><clipPath id=\"clip0_198_1747\" data-v-2e7bfd08><rect width=\"15.794\" height=\"15.793\" fill=\"white\" data-v-2e7bfd08></rect></clipPath></defs></svg></figure>", 1)
const _hoisted_3 = [
  _hoisted_2
]

import { watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyModal',
  props: { isOpen: { type: Boolean, required: true }, height: String, width: String, toggleModal: { type: Function, required: true }, zIndex: Number, className: String, id: String },
  setup(__props) {

const props = __props

watch(() => props.isOpen, (newValue) => {
  if (newValue) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[2] || (_cache[2] = ($event: any) => {__props.toggleModal(false);}),
    class: _normalizeClass(["modal", [__props.isOpen ? ('open ' + __props.className ?? '') : ('closed ' + __props.className ?? '')]]),
    style: _normalizeStyle({zIndex:(__props.zIndex ?? 2) - 1})
  }, [
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
      style: _normalizeStyle({ maxHeight: __props.height, maxWidth: __props.width, zIndex: __props.zIndex}),
      id: __props.id ? __props.id:'',
      class: _normalizeClass(["modal__content", [__props.isOpen ? ('open ' ?? '') : ('closed ' ?? '')]])
    }, [
      _createElementVNode("button", {
        class: "close-modal",
        onClick: _cache[0] || (_cache[0] = ($event: any) => {__props.toggleModal(false);})
      }, _hoisted_3),
      _renderSlot(_ctx.$slots, "default")
    ], 14, _hoisted_1)
  ], 6))
}
}

})